// lib/getBaseUrl.ts - matches cci_client pattern for consistent client/server URL handling
export const getBaseUrl = () => {
  if (typeof window === "undefined") {
    // Server-side
    return process.env.NEXT_PUBLIC_STRAPI_URL_INTERNAl!;
  }
  // Client-side - must use public URL to avoid Chrome Local Network Access prompt
  return process.env.NEXT_PUBLIC_STRAPI_URL!;
};

/** Use for URLs in HTML (favicon, img src, backgroundImage) - avoids Local Network Access prompt */
export const getPublicBaseUrl = () => process.env.NEXT_PUBLIC_STRAPI_URL || "";
